export class Couponsection {
  searchText: string;
  title: string;
  couponvalue: string;
  couponcount: string;
  coupondetails: string;
  coupontype: string;
  startdate: any;
  enddate: any;
  bulkStartDate: any;
  bulkEndDate: any;
}
